<template>
    <video-player :options="videoOptions" v-if="instanceHasVideo && shouldLoadVideoPlayer"></video-player>
    <div v-else>
       <div class="row no-gutters">
           <div class="col-10 offset-1">
               <div class="alert alert-primary mt-2">
                   {{ $t('UI_MEDIA_NOTE_SELECTED_FOR_INSTANCE') }}
               </div>
               <button class="btn btn-outline-primary" @click="openMediaSelectModal">
                   {{ $t('UI_MEDIA_SELECT') }}
               </button>
           </div>
       </div>

       <SweetModal ref="mediaSelectModal" :title="$t('UI_MEDIA_SELECT_MODAL_TITLE')" :width="600" v-on:close="previewing = null" :blocking="true" :pulse-on-block="false">

           <div class="row">
               <div class="col-md-12">
                   <label for="searchBar">
                       <strong>{{ $t("UI_MEDIA_SEARCH_LABEL") }}</strong>
                   </label>
                   <div class="input-group">
                       <input type="text" class="form-control" :placeholder="$t('UI_MEDIA_SEARCH_PLACEHOLDER')" id="searchBar" v-model="searchString" v-on:keyup.enter="fetchMedia">
                       <div class="input-group-append">
                           <button class="btn btn-outline-secondary" type="button" @click="fetchMedia">
                               <i class="fa fa-search"></i>
                           </button>
                       </div>
                   </div>
               </div>
           </div>

           <div class="row">
               <div class="col-md-12">
                   <loading :active.sync="isLoading"></loading>
               </div>
           </div>

           <div class="row mt-3" v-for="chunk in chunkedMedia" v-if="mediaAvailable">
               <div class="col-md-12" v-for="media in chunk">
                   <div class="card h-100">
                       <div class="card-body text-center">
                           <h5 class="card-title mb-1">{{ media.title }}</h5>

                           <div  class="embed-responsive embed-responsive-16by9" v-if="previewing === media.mediaId">
                               <video class="embed-responsive-item" controls autoplay>
                                   <source :src="media.url">
                               </video>
                           </div>
                           <img class="img-fluid" :src="media.thumbnail" alt="Card image cap" v-else>

                           <small>{{ media.datetime | moment("DD.MM.YYYY HH:mm:ss") }}</small>
                       </div>
                       <div class="card-footer bg-white">
                           <button class="float-left btn btn-primary btn-sm" @click="assignMediaToInstance(media)">
                               {{ $t("UI_MODEL_BUTTON_SELECT")}}
                           </button>
                           <button  class="float-right btn btn-outline-secondary btn-sm" @click="toggleMediaPreview(media)">
                               {{ $t("UI_MEDIA_PREVIEW_BUTTON")}}
                           </button>
                       </div>
                   </div>
               </div>
           </div>

           <div class="row  mt-3" v-else>
               <div class="col-md-12">
                   <div class="alert alert-info">
                       {{ $t('UI_MEDIA_NONE_AVAILABLE') }}
                   </div>
               </div>
           </div>

           <div slot="button">
               <button class="btn btn-secondary ml-1"  @click="$refs.mediaSelectModal.close()">{{ $t("UI_MODAL_BUTTON_CLOSE") }}</button>
           </div>
       </SweetModal>
   </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { SweetModal } from 'sweet-modal-vue';
import chunk from 'lodash/chunk';
import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';
import VideoPlayer from '../../../../includes/VideoPlayer';

const MediaRepository = RepositoryFactory.get('media');
const InstanceRepository = RepositoryFactory.get('instances');

export default {
  name: 'VideoContainer',
  components: { VideoPlayer, Loading, SweetModal },
  props: {
    instance: Object,
  },
  mounted() {
    this.shouldLoadVideoPlayer = false;
    if (this.instance.video !== null && this.instance.video !== '') {
      this.videoOptions.sources[0].src = this.instance.video;
	        this.shouldLoadVideoPlayer = true;
    }
  },
  data() {
    1;

    return {
      isLoading: false,
      mediaList: null,
      searchString: null,
      previewing: null,
      shouldLoadVideoPlayer: false,
      videoOptions: {
        autoplay: false,
        controls: true,
        aspectRatio: '16:9',
        fluid: true,
        sources: [
          {
            src: null,
            type: 'video/mp4',
          },
        ],
      },
    };
  },
  computed: {
    /**
       * Checks if the endpoint returned at least one valid medium
       */
    mediaAvailable() {
      if (this.mediaList !== null) {
        return this.mediaList.length > 0;
      }
      return false;
    },
    /**
       * Chunk the Media into smaller pieces
       */
    chunkedMedia() {
      return chunk(this.mediaList, 1);
    },
    /**
       * Checks if the active Instance has a video connected.
       */
    instanceHasVideo() {
      return this.instance.video != null;
    },
  },
  methods: {
    /**
       * Toogle one medium that is currently previewd.
       */
    toggleMediaPreview(medium) {
      if (this.previewing === null || this.previewing !== medium.mediaId) this.previewing = medium.mediaId;
      else this.previewing = null;
    },
    /**
       * Connects the selected media to the instance.
       */
    async assignMediaToInstance(media) {
      this.isLoading = true;
      await MediaRepository.select(media.mediaId).then((response) => {
        this.isLoading = false;
        this.$refs.mediaSelectModal.close();
        this.$snotify.info(this.$t('UI_MEDIA_SELECTED'));

        this.shouldLoadVideoPlayer = false;
        InstanceRepository.refetchActive(false).then(() => {
          	this.videoOptions.sources[0].src = this.instance.video;
          	this.shouldLoadVideoPlayer = true;
        });
      }).catch((error) => { this.isLoading = false; });
    },
    /**
       * Fetches Media from the endpoint
       */
    async fetchMedia() {
      this.isLoading = true;
      await MediaRepository.search(this.searchString).then((response) => {
        this.mediaList = response.data.list;
        this.isLoading = false;
      }).catch((error) => { this.isLoading = false; });
    },
    /**
       * Opens the Modal to Select Media.
       */
    async openMediaSelectModal() {
      this.$refs.mediaSelectModal.open();
      await this.fetchMedia();
    },
  },
};
</script>
